const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      suite: 'Portal',
      services: 'Services',
      company: 'Company',
      contact: 'Contact',
      login: 'Login',
      getStarted: 'Get Started Free',
    },

    // Footer
    footer: {
      tagline: 'Professional Automotive Software Platform',
    },

    // HomePage
    home: {
      heroLabel: 'Professional Automotive Software',
      heroTitle1: 'All-in-one platform for',
      heroTitle2: 'chip tuning & automotive',
      heroTitle3: 'solution',
      heroSubtext: 'Built for professionals. Fast and reliable.',
      heroSupporting: 'Supporting',
      heroVehicles: '',
      heroCta: 'Get Started Free',
      heroAccess: 'Access RTEQ Portal',
      cars: 'Cars',
      bikes: 'Bikes',
      marine: 'Marine',
      trucks: 'Trucks',
      agriculture: 'Agriculture',
      modulesLabel: 'What We Offer',
      modulesTitle: 'Core Platform Modules',
      modulesDesc: 'RTEQ Portal is a cloud-based automotive platform that allows garages and tuning professionals to manage their entire workflow',
      moduleFileServices: 'File Services',
      moduleFileServicesDesc: 'Upload and receive ECU tuning files with professional processing',
      moduleRemoteDiag: 'Pass-Thru',
      moduleRemoteDiagDesc: 'Perform live troubleshooting and fault analysis remotely',
      moduleToolsSoftware: 'Tools & Software',
      moduleToolsSoftwareDesc: 'Access OEM diagnostic tools through Pass-Thru devices',
      modulesCta: 'Start using RTEQ Portal today — Free registration',
      modulesCtaBtn: 'Create Free Account',
      whatIsTitle: 'What is RTEQ Portal?',
      whatIsDesc: 'RTEQ Portal is a cloud-based automotive platform that allows garages and tuning professionals to:',
      whatIsItem1: 'Upload and receive ECU tuning files',
      whatIsItem2: 'Perform remote diagnostics',
      whatIsItem3: 'Immediate technical support',
      whatIsItem4: 'Manage data flow in one centralized system',
      whatIsLearnMore: 'Learn More About Portal',
      whatIsViewServices: 'View Our Services',
    },

    // SuitePage
    suite: {
      heroLabel: 'RTEQ Portal',
      heroTitle1: 'The Complete Automotive',
      heroTitle2: 'Software Platform',
      heroDesc: 'RTEQ Portal is a modular platform designed to manage the full tuning and diagnostic workflow from start to finish. Built for professionals who demand efficiency and reliability.',
      heroCta: 'Get Started Free',
      heroAccess: 'Access RTEQ Portal',
      workflowLabel: 'Workflow',
      workflowTitle: 'How It Works',
      step1Title: 'Create Job',
      step1Desc: 'Start a new vehicle job in the system',
      step2Title: 'Upload File',
      step2Desc: 'Submit ECU file or request service',
      step3Title: 'Processing',
      step3Desc: 'Our engineers handle your request',
      step4Title: 'Download',
      step4Desc: 'Receive your processed files',
      step5Title: 'Apply',
      step5Desc: 'Flash the tuned file to vehicle',
      featuresLabel: 'Features',
      featuresTitle: 'System Modules',
      featuresDesc: 'Each module is designed to handle specific aspects of your workflow',
      modDashboard: 'Dashboard',
      modDashboardDesc: 'Overview of all activities and stats',
      modJobs: 'Jobs',
      modJobsDesc: 'Manage all vehicle tuning jobs',
      modVehicles: 'Vehicles',
      modVehiclesDesc: 'Complete vehicle database',
      modFiles: 'Files',
      modFilesDesc: 'File management and history',
      modDiagnostics: 'Diagnostics',
      modDiagnosticsDesc: 'Remote troubleshooting tools',
      modTools: 'Tools',
      modToolsDesc: 'Integrated software solutions',
      modWallet: 'Wallet',
      modWalletDesc: 'Credits and billing management',
      benefitsLabel: 'Why Choose Us',
      benefitsTitle: 'Key Benefits',
      benefit1Title: 'Fast Turnaround',
      benefit1Desc: 'Quick processing times for all file services',
      benefit2Title: 'Centralized Workflow',
      benefit2Desc: 'Everything in one place, no more scattered tools',
      benefit3Title: 'Scalable Solution',
      benefit3Desc: 'Grows with your garage or business',
      benefit4Title: 'Real-time Communication',
      benefit4Desc: 'Direct channel to engineers and support',
      ctaTitle: 'Ready to streamline your workflow?',
      ctaDesc: 'Join professionals worldwide who trust RTEQ Portal for their automotive software needs.',
      ctaBtn: 'Create Free Account',
      ctaBtn2: 'View Services',
    },

    // ServicesPage
    services: {
      heroLabel: 'Our Services',
      heroTitle1: 'Professional',
      heroTitle2: 'Automotive Solutions',
      heroDesc: 'Comprehensive automotive software services tailored for professionals. From ECU tuning to remote diagnostics, we\'ve got you covered.',
      ecuTitle: 'ECU File Services',
      ecuDesc: 'Professional ECU tuning for all vehicle types',
      ecuStage1: 'Stage 1 Tuning',
      ecuStage1Desc: 'Safe power gains with stock hardware',
      ecuStage2: 'Stage 2 Tuning',
      ecuStage2Desc: 'Enhanced performance with bolt-on modifications',
      ecuStage3: 'Stage 3 Tuning',
      ecuStage3Desc: 'Maximum power with forced induction upgrades',
      ecuDpf: 'DPF Solutions',
      ecuDpfDesc: 'Diesel particulate filter solutions',
      ecuEgr: 'EGR Solutions',
      ecuEgrDesc: 'Exhaust gas recirculation optimization',
      ecuAdblue: 'AdBlue Solutions',
      ecuAdblueDesc: 'AdBlue system',
      ecuPops: 'Pops & Bangs',
      ecuPopsDesc: 'Exhaust pop tuning',
      ecuCustom: 'Custom Tuning',
      ecuCustomDesc: 'Bespoke solutions for unique requirements',
      diagTitle: 'Remote Diagnostics',
      diagDesc: 'Live troubleshooting and expert support',
      diagLive: 'Live Troubleshooting',
      diagLiveDesc: 'Real-time diagnostic support with our engineers',
      diagFault: 'Fault Analysis',
      diagFaultDesc: 'Comprehensive fault code analysis and solutions',
      diagEcu: 'ECU Support',
      diagEcuDesc: 'Expert assistance with ECU-related issues',
      diagRemote: 'Remote Assistance',
      diagRemoteDesc: 'Screen sharing and guided diagnostics',
      toolsTitle: 'Software & Tools',
      toolsDesc: 'Integrated solutions for professionals',
      toolsFlash: 'Flash Tool Compatibility',
      toolsFlashDesc: 'Support for all major flash tools and protocols',
      toolsAdvanced: 'Advanced Solutions',
      toolsAdvancedDesc: 'Complex ECU modifications and repairs',
      toolsIntegration: 'Software Integration',
      toolsIntegrationDesc: 'Seamless integration with your existing tools',
      ctaTitle: 'Ready to access our services?',
      ctaDesc: 'All services are available through the RTEQ Portal platform. Create your free account and start using our professional automotive solutions today.',
      ctaBtn: 'Get Started Free',
      ctaBtn2: 'Learn About Portal',
    },

    // CompanyPage
    company: {
      heroLabel: 'About Us',
      heroTitle1: 'RTEQ',
      heroTitle2: ' Solutions',
      heroDesc: 'One of the few platforms worldwide offering over 100 specialized services in the automotive tuning and diagnostics industry',
      aboutTitle: 'About RTEQ',
      aboutP1: 'RTEQ is one of the few platforms worldwide offering over 100 specialized services in the automotive tuning and diagnostics industry.',
      aboutP2: 'We operate as a world-class technical partner, combining deep industry knowledge with advanced tools and infrastructure. Our team includes:',
      aboutTeam1: '2 certified WinOLS trainers',
      aboutTeam2: '2 highly experienced vehicle technicians',
      aboutP3: 'This foundation allows us to deliver a consistently high level of expertise, precision, and reliability across every service we provide.',
      aboutP4: 'RTEQ is built to support modern automotive professionals by offering a centralized environment for tuning, diagnostics, and technical problem-solving. From standard ECU remapping to advanced engineering solutions, our approach is focused on efficiency, accuracy, and performance.',
      aboutP5: 'We continuously evolve by adopting new technologies and refining our processes, ensuring that our partners always stay ahead in a fast-moving industry.',
      statsServices: 'Services',
      statsGlobal: 'Global',
      statsCoverage: 'Coverage',
      statsSupport: 'Support',
      commitLabel: 'What We Stand For',
      commitTitle: 'Our Commitment',
      commitDesc: 'At RTEQ, we are committed to delivering solutions that professionals can rely on every day. We don\'t just provide services — we build long-term partnerships based on trust, performance, and consistency.',
      commitTrust: 'RTEQ is a trusted partner for professionals who demand:',
      commitQuality: 'Quality',
      commitQualityDesc: 'High-standard solutions with attention to detail',
      commitAccuracy: 'Accuracy',
      commitAccuracyDesc: 'Precise results backed by technical expertise',
      commitTech: 'Cutting-edge Technology',
      commitTechDesc: 'Modern tools and advanced methodologies',
      commitBottom: 'Our commitment is to ensure that every job, every file, and every interaction meets the expectations of professionals who depend on',
      commitSpeed: 'speed',
      commitReliability: 'reliability',
      commitExcellence: 'technical excellence',
      ctaTitle: 'Ready to work with us?',
      ctaDesc: 'Join professionals worldwide who trust RTEQ for their automotive software needs.',
      ctaBtn: 'Contact Us',
      ctaBtn2: 'View Services',
    },

    // ContactPage
    contact: {
      heroLabel: 'Get In Touch',
      heroTitle1: 'Contact',
      heroTitle2: ' Us',
      heroDesc: 'Have questions? We\'re here to help. Reach out to us through any of the channels below.',
      formTitle: 'Send us a message',
      formName: 'Name',
      formNamePlaceholder: 'Your name',
      formEmail: 'Email',
      formEmailPlaceholder: 'your@email.com',
      formMessage: 'Message',
      formMessagePlaceholder: 'How can we help you?',
      formSending: 'Sending...',
      formSend: 'Send Message',
      formError: 'Please fill in all fields',
      formFail: 'Failed to send message. Please try again.',
      cyprus: 'Cyprus',
      greece: 'Greece',
      email: 'Email',
      address: 'Address',
      businessHours: 'Business Hours',
      monFri: 'Monday - Friday',
      ctaTitle: 'Ready to get started?',
      ctaDesc: 'Create your free account today and access the full RTEQ Portal platform.',
      ctaBtn: 'Get Started Free',
      bottomTitle: 'Still have questions?',
      bottomDesc: 'Explore our services or learn more about what RTEQ Portal can do for your business.',
      bottomBtn: 'View Services',
      bottomBtn2: 'Learn About Portal',
    },
  },

  el: {
    // Navigation
    nav: {
      home: 'Αρχική',
      suite: 'Portal',
      services: 'Υπηρεσίες',
      company: 'Εταιρεία',
      contact: 'Επικοινωνία',
      login: 'Σύνδεση',
      getStarted: 'Ξεκινήστε Δωρεάν',
    },

    // Footer
    footer: {
      tagline: 'Επαγγελματική Πλατφόρμα Λογισμικού Αυτοκινήτου',
    },

    // HomePage
    home: {
      heroLabel: 'Επαγγελματικό Λογισμικό Αυτοκινήτου',
      heroTitle1: 'Ολοκληρωμένη πλατφόρμα για',
      heroTitle2: 'chip tuning & automotive',
      heroTitle3: 'solution',
      heroSubtext: 'Σχεδιασμένο για επαγγελματίες. Γρήγορο και αξιόπιστο.',
      heroSupporting: 'Υποστηρίζει',
      heroVehicles: '',
      heroCta: 'Ξεκινήστε Δωρεάν',
      heroAccess: 'Πρόσβαση στο RTEQ Portal',
      cars: 'Αυτοκίνητα',
      bikes: 'Μοτοσικλέτες',
      marine: 'Σκάφη',
      trucks: 'Φορτηγά',
      agriculture: 'Γεωργικά',
      modulesLabel: 'Τι Προσφέρουμε',
      modulesTitle: 'Βασικές Ενότητες Πλατφόρμας',
      modulesDesc: 'Το RTEQ Portal είναι μια cloud πλατφόρμα αυτοκινήτου που επιτρέπει σε συνεργεία και επαγγελματίες tuning να διαχειρίζονται ολόκληρη τη ροή εργασίας τους',
      moduleFileServices: 'Υπηρεσίες Αρχείων',
      moduleFileServicesDesc: 'Ανεβάστε και λάβετε αρχεία ECU tuning με επαγγελματική επεξεργασία',
      moduleRemoteDiag: 'Pass-Thru Απομακρυσμένη Σύνδεση',
      moduleRemoteDiagDesc: 'Ζωντανή αντιμετώπιση προβλημάτων και ανάλυση βλαβών εξ αποστάσεως',
      moduleToolsSoftware: 'Εργαλεία & Λογισμικό',
      moduleToolsSoftwareDesc: 'Πρόσβαση σε εργαλεία διαγνωστικών OEM μέσω συσκευών Pass-Thru',
      modulesCta: 'Ξεκινήστε να χρησιμοποιείτε το RTEQ Portal σήμερα — Δωρεάν εγγραφή',
      modulesCtaBtn: 'Δωρεάν Εγγραφή',
      whatIsTitle: 'Τι είναι το RTEQ Portal;',
      whatIsDesc: 'Το RTEQ Portal είναι μια cloud πλατφόρμα αυτοκινήτου που επιτρέπει σε συνεργεία και επαγγελματίες tuning να:',
      whatIsItem1: 'Ανεβάζουν και λαμβάνουν αρχεία ECU tuning',
      whatIsItem2: 'Απομακρυσμένη τεχνική Pass-Thru υποστήριξη',
      whatIsItem3: 'Άμεση τεχνική υποστήριξη',
      whatIsItem4: 'Διαχειρίζονται τη ροή δεδομένων σε ένα κεντρικό σύστημα',
      whatIsLearnMore: 'Μάθετε Περισσότερα για το Portal',
      whatIsViewServices: 'Δείτε τις Υπηρεσίες μας',
    },

    // SuitePage
    suite: {
      heroLabel: 'RTEQ Portal',
      heroTitle1: 'Η Ολοκληρωμένη Πλατφόρμα',
      heroTitle2: 'Λογισμικού Αυτοκινήτου',
      heroDesc: 'Το RTEQ Portal είναι μια αρθρωτή πλατφόρμα σχεδιασμένη να διαχειρίζεται ολόκληρη τη ροή εργασίας tuning και διαγνωστικών από την αρχή μέχρι το τέλος. Σχεδιασμένο για επαγγελματίες που απαιτούν αποτελεσματικότητα και αξιοπιστία.',
      heroCta: 'Ξεκινήστε Δωρεάν',
      heroAccess: 'Πρόσβαση στο RTEQ Portal',
      workflowLabel: 'Ροή Εργασίας',
      workflowTitle: 'Πώς Λειτουργεί',
      step1Title: 'Δημιουργία Εργασίας',
      step1Desc: 'Ξεκινήστε μια νέα εργασία οχήματος στο σύστημα',
      step2Title: 'Ανέβασμα Αρχείου',
      step2Desc: 'Υποβάλετε αρχείο ECU ή αίτημα υπηρεσίας',
      step3Title: 'Επεξεργασία',
      step3Desc: 'Οι Τεχνικοί Οχημάτων μας επεξεργάζονται το αίτημά σας',
      step4Title: 'Λήψη',
      step4Desc: 'Λάβετε τα επεξεργασμένα αρχεία σας',
      step5Title: 'Εφαρμογή',
      step5Desc: 'Εγγράψτε το αρχείο tuning στο όχημα',
      featuresLabel: 'Χαρακτηριστικά',
      featuresTitle: 'Ενότητες Συστήματος',
      featuresDesc: 'Κάθε ενότητα είναι σχεδιασμένη να διαχειρίζεται συγκεκριμένες πτυχές της ροής εργασίας σας',
      modDashboard: 'Πίνακας Ελέγχου',
      modDashboardDesc: 'Επισκόπηση όλων των δραστηριοτήτων και στατιστικών',
      modJobs: 'Εργασίες',
      modJobsDesc: 'Διαχείριση όλων των εργασιών tuning οχημάτων',
      modVehicles: 'Οχήματα',
      modVehiclesDesc: 'Πλήρης βάση δεδομένων οχημάτων',
      modFiles: 'Αρχεία',
      modFilesDesc: 'Διαχείριση αρχείων και ιστορικό',
      modDiagnostics: 'Διαγνωστικά',
      modDiagnosticsDesc: 'Εργαλεία απομακρυσμένης αντιμετώπισης προβλημάτων',
      modTools: 'Εργαλεία',
      modToolsDesc: 'Ενσωματωμένες λύσεις λογισμικού',
      modWallet: 'Πορτοφόλι',
      modWalletDesc: 'Διαχείριση πιστώσεων και χρεώσεων',
      benefitsLabel: 'Γιατί να μας Επιλέξετε',
      benefitsTitle: 'Βασικά Πλεονεκτήματα',
      benefit1Title: 'Γρήγορη Εκτέλεση',
      benefit1Desc: 'Γρήγοροι χρόνοι επεξεργασίας για όλες τις υπηρεσίες αρχείων',
      benefit2Title: 'Κεντρική Ροή Εργασίας',
      benefit2Desc: 'Όλα σε ένα μέρος, χωρίς διάσπαρτα εργαλεία',
      benefit3Title: 'Επεκτάσιμη Λύση',
      benefit3Desc: 'Μεγαλώνει μαζί με το συνεργείο ή την επιχείρησή σας',
      benefit4Title: 'Επικοινωνία σε Πραγματικό Χρόνο',
      benefit4Desc: 'Άμεσο κανάλι επικοινωνίας με Τεχνικούς Οχημάτων και υποστήριξη',
      ctaTitle: 'Έτοιμοι να βελτιστοποιήσετε τη ροή εργασίας σας;',
      ctaDesc: 'Γίνετε μέλος μιας κοινότητας επαγγελματιών παγκοσμίως που εμπιστεύονται το RTEQ Portal για τις ανάγκες τους σε λογισμικό αυτοκινήτου.',
      ctaBtn: 'Δωρεάν Εγγραφή',
      ctaBtn2: 'Δείτε Υπηρεσίες',
    },

    // ServicesPage
    services: {
      heroLabel: 'Οι Υπηρεσίες μας',
      heroTitle1: 'Επαγγελματικές',
      heroTitle2: 'Λύσεις Αυτοκινήτου',
      heroDesc: 'Ολοκληρωμένες υπηρεσίες λογισμικού αυτοκινήτου σχεδιασμένες για επαγγελματίες. Από ECU tuning μέχρι απομακρυσμένη σύνδεση, σας καλύπτουμε πλήρως.',
      ecuTitle: 'Υπηρεσίες Αρχείων ECU',
      ecuDesc: 'Επαγγελματικό ECU tuning για όλους τους τύπους οχημάτων',
      ecuStage1: 'Stage 1 Tuning',
      ecuStage1Desc: 'Ασφαλής αύξηση ισχύος με εργοστασιακό εξοπλισμό',
      ecuStage2: 'Stage 2 Tuning',
      ecuStage2Desc: 'Ενισχυμένη απόδοση με τροποποιήσεις bolt-on',
      ecuStage3: 'Stage 3 Tuning',
      ecuStage3Desc: 'Μέγιστη ισχύς με αναβαθμίσεις forced induction',
      ecuDpf: 'Λύσεις DPF',
      ecuDpfDesc: 'Λύσεις φίλτρου σωματιδίων diesel',
      ecuEgr: 'Λύσεις EGR',
      ecuEgrDesc: 'Βελτιστοποίηση ανακυκλοφορίας καυσαερίων',
      ecuAdblue: 'Λύσεις AdBlue',
      ecuAdblueDesc: 'Συστήματος AdBlue',
      ecuPops: 'Pops & Bangs',
      ecuPopsDesc: 'Tuning ήχων εξάτμισης pop',
      ecuCustom: 'Custom Tuning',
      ecuCustomDesc: 'Εξατομικευμένες λύσεις για μοναδικές απαιτήσεις',
      diagTitle: 'Απομακρυσμένη Σύνδεση',
      diagDesc: 'Ζωντανή αντιμετώπιση προβλημάτων και ειδική υποστήριξη',
      diagLive: 'Ζωντανή Αντιμετώπιση Προβλημάτων',
      diagLiveDesc: 'Διαγνωστική υποστήριξη σε πραγματικό χρόνο με τους Τεχνικούς Οχημάτων μας',
      diagFault: 'Ανάλυση Βλαβών',
      diagFaultDesc: 'Ολοκληρωμένη ανάλυση κωδικών βλάβης και λύσεις',
      diagEcu: 'Υποστήριξη ECU',
      diagEcuDesc: 'Ειδική βοήθεια σε θέματα σχετικά με ECU',
      diagRemote: 'Απομακρυσμένη Βοήθεια',
      diagRemoteDesc: 'Κοινή χρήση οθόνης και καθοδηγούμενα διαγνωστικά',
      toolsTitle: 'Λογισμικό & Εργαλεία',
      toolsDesc: 'Ολοκληρωμένες λύσεις για επαγγελματίες',
      toolsFlash: 'Συμβατότητα Flash Tool',
      toolsFlashDesc: 'Υποστήριξη όλων των κύριων flash tools και πρωτοκόλλων',
      toolsAdvanced: 'Προηγμένες Λύσεις',
      toolsAdvancedDesc: 'Σύνθετες τροποποιήσεις και επισκευές ECU',
      toolsIntegration: 'Ενσωμάτωση Λογισμικού',
      toolsIntegrationDesc: 'Απρόσκοπτη ενσωμάτωση με τα υπάρχοντα εργαλεία σας',
      ctaTitle: 'Έτοιμοι να αποκτήσετε πρόσβαση στις υπηρεσίες μας;',
      ctaDesc: 'Όλες οι υπηρεσίες είναι διαθέσιμες μέσω της πλατφόρμας RTEQ Portal. Δημιουργήστε τον δωρεάν λογαριασμό σας και αρχίστε να χρησιμοποιείτε τις επαγγελματικές μας λύσεις σήμερα.',
      ctaBtn: 'Ξεκινήστε Δωρεάν',
      ctaBtn2: 'Μάθετε για το Portal',
    },

    // CompanyPage
    company: {
      heroLabel: 'Σχετικά με Εμάς',
      heroTitle1: 'RTEQ',
      heroTitle2: ' Solutions',
      heroDesc: 'Μία από τις λίγες πλατφόρμες παγκοσμίως που προσφέρει πάνω από 100 εξειδικευμένες υπηρεσίες στη βιομηχανία tuning και διαγνωστικών αυτοκινήτου',
      aboutTitle: 'Σχετικά με RTEQ',
      aboutP1: 'Η RTEQ είναι μία από τις λίγες πλατφόρμες παγκοσμίως που προσφέρει πάνω από 100 εξειδικευμένες υπηρεσίες στη βιομηχανία tuning και διαγνωστικών αυτοκινήτου.',
      aboutP2: 'Λειτουργούμε ως τεχνικός συνεργάτης παγκόσμιας κλάσης, συνδυάζοντας βαθιά γνώση της βιομηχανίας με προηγμένα εργαλεία και υποδομές. Η ομάδα μας περιλαμβάνει:',
      aboutTeam1: '2 πιστοποιημένους εκπαιδευτές WinOLS',
      aboutTeam2: '2 έμπειρους Τεχνικούς Οχημάτων',
      aboutP3: 'Αυτή η βάση μας επιτρέπει να παρέχουμε ένα σταθερά υψηλό επίπεδο εξειδίκευσης, ακρίβειας και αξιοπιστίας σε κάθε υπηρεσία που προσφέρουμε.',
      aboutP4: 'Η RTEQ είναι σχεδιασμένη να υποστηρίζει σύγχρονους επαγγελματίες αυτοκινήτου, προσφέροντας ένα κεντρικό περιβάλλον για tuning, διαγνωστικά και τεχνική επίλυση προβλημάτων. Από τυπικό ECU remapping μέχρι προηγμένες μηχανολογικές λύσεις, η προσέγγισή μας επικεντρώνεται στην αποτελεσματικότητα, την ακρίβεια και την απόδοση.',
      aboutP5: 'Εξελισσόμαστε συνεχώς υιοθετώντας νέες τεχνολογίες και βελτιώνοντας τις διαδικασίες μας, διασφαλίζοντας ότι οι συνεργάτες μας βρίσκονται πάντα μπροστά σε μια ταχέως εξελισσόμενη βιομηχανία.',
      statsServices: 'Υπηρεσίες',
      statsGlobal: 'Παγκόσμια',
      statsCoverage: 'Κάλυψη',
      statsSupport: 'Υποστήριξη',
      commitLabel: 'Τι Πρεσβεύουμε',
      commitTitle: 'Η Δέσμευσή μας',
      commitDesc: 'Στην RTEQ, δεσμευόμαστε να παρέχουμε λύσεις στις οποίες οι επαγγελματίες μπορούν να βασίζονται καθημερινά. Δεν παρέχουμε απλά υπηρεσίες — χτίζουμε μακροχρόνιες συνεργασίες βασισμένες στην εμπιστοσύνη, την απόδοση και τη συνέπεια.',
      commitTrust: 'Η RTEQ είναι ένας αξιόπιστος συνεργάτης για επαγγελματίες που απαιτούν:',
      commitQuality: 'Ποιότητα',
      commitQualityDesc: 'Λύσεις υψηλών προδιαγραφών με προσοχή στη λεπτομέρεια',
      commitAccuracy: 'Ακρίβεια',
      commitAccuracyDesc: 'Ακριβή αποτελέσματα υποστηριζόμενα από τεχνική εξειδίκευση',
      commitTech: 'Τεχνολογία Αιχμής',
      commitTechDesc: 'Σύγχρονα εργαλεία και προηγμένες μεθοδολογίες',
      commitBottom: 'Η δέσμευσή μας είναι να διασφαλίζουμε ότι κάθε εργασία, κάθε αρχείο και κάθε αλληλεπίδραση ανταποκρίνεται στις προσδοκίες επαγγελματιών που βασίζονται στην',
      commitSpeed: 'ταχύτητα',
      commitReliability: 'αξιοπιστία',
      commitExcellence: 'τεχνική αριστεία',
      ctaTitle: 'Έτοιμοι να συνεργαστείτε μαζί μας;',
      ctaDesc: 'Γίνετε μέλος μιας κοινότητας επαγγελματιών παγκοσμίως που εμπιστεύονται την RTEQ για τις ανάγκες τους σε λογισμικό αυτοκινήτου.',
      ctaBtn: 'Επικοινωνήστε μαζί μας',
      ctaBtn2: 'Δείτε Υπηρεσίες',
    },

    // ContactPage
    contact: {
      heroLabel: 'Επικοινωνήστε μαζί μας',
      heroTitle1: 'Επικοινωνία',
      heroTitle2: '',
      heroDesc: 'Έχετε ερωτήσεις; Είμαστε εδώ για να βοηθήσουμε. Επικοινωνήστε μαζί μας μέσω οποιουδήποτε από τα παρακάτω κανάλια.',
      formTitle: 'Στείλτε μας μήνυμα',
      formName: 'Όνομα',
      formNamePlaceholder: 'Το όνομά σας',
      formEmail: 'Email',
      formEmailPlaceholder: 'your@email.com',
      formMessage: 'Μήνυμα',
      formMessagePlaceholder: 'Πώς μπορούμε να σας βοηθήσουμε;',
      formSending: 'Αποστολή...',
      formSend: 'Αποστολή Μηνύματος',
      formError: 'Παρακαλώ συμπληρώστε όλα τα πεδία',
      formFail: 'Αποτυχία αποστολής μηνύματος. Παρακαλώ δοκιμάστε ξανά.',
      cyprus: 'Κύπρος',
      greece: 'Ελλάδα',
      email: 'Email',
      address: 'Διεύθυνση',
      businessHours: 'Ώρες Λειτουργίας',
      monFri: 'Δευτέρα - Παρασκευή',
      ctaTitle: 'Έτοιμοι να ξεκινήσετε;',
      ctaDesc: 'Δημιουργήστε τον δωρεάν λογαριασμό σας σήμερα και αποκτήστε πρόσβαση στην πλήρη πλατφόρμα RTEQ Portal.',
      ctaBtn: 'Ξεκινήστε Δωρεάν',
      bottomTitle: 'Έχετε ακόμα ερωτήσεις;',
      bottomDesc: 'Εξερευνήστε τις υπηρεσίες μας ή μάθετε περισσότερα για το τι μπορεί να κάνει το RTEQ Portal για την επιχείρησή σας.',
      bottomBtn: 'Δείτε Υπηρεσίες',
      bottomBtn2: 'Μάθετε για το Portal',
    },
  },
};

export default translations;
